export default __webpack_public_path__ + "static/media/add.24b41f7a.svg";